<template>
  <div class="login-page">
    <!-- <div style="position: absolute; top: 20px; right: 20px; z-index: 1">
      <a-dropdown overlayClassName="ant-deep-dropdown">
        <span class="drop-down" style="padding: 0 12px; font-size: 20px; color: white">
          <a-icon type="global" style="" />
        </span>
        <a-menu class="menu-item" mode="inline" slot="overlay" @click="changeLanguage">
          <a-menu-item key="zh">
            <span>🇨🇳 简体中文</span>
          </a-menu-item>
          <a-menu-item key="en">
            <span>🇺🇸 English</span>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div> -->
    <div class="login-content">
      <div class="form-login">
        <div class="login-title">
          <a-icon type="left" @click="goBack" />
          {{ $t('base.forgetPassword') }}
        </div>
        <forgetPassword />
      </div>
    </div>
  </div>
</template>

<script>
import forgetPassword from './components/forget-password.vue'
export default {
  name: 'ForgetPwd',
  components: {
    forgetPassword,
  },
  computed: {
    loginType() {
      return this.$store.getters.LoginInfo.loginType
    },
  },
  data() {
    return {
      captchaModal: false,
    }
  },
  methods: {
    // 切换语言
    changeLanguage({ key }) {
      this.$store.dispatch('setLang', key)
    },
    changeLoginMethod() {
      this.captchaModal = true
    },
    changeClose() {
      this.captchaModal = false
    },
    skipToRegisterPage() {
      this.$router.push({
        path: '/register',
      })
    },
    goBack() {
      this.$router.back()
    },
  },
}
</script>

<style lang="less" scoped>
.login-page {
  width: 100%;
  height: 100vh;
  background-image: url('../../assets/images/login-bg.png');
  background-size: cover;
  background-repeat: no-repeat;

  .login-content {
    width: 500px;
    height: 100%;
    background-color: #050505;
    opacity: 0.9;
  }

  .login-title {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 20px;
    color: #ffffff;
    line-height: 33px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-bottom: 25px;
    .anticon-left {
      margin-right: 20px;
      height: 14px;
      width: 7px;
    }
  }

  .form-login {
    position: fixed;
    left: 67px;
    top: 200px;
  }
}

.drag {
  -webkit-app-region: drag;
}

.other-box {
  width: 460px;
  margin-top: 30px;
  display: flex;
  align-items: center;
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 12px;
  color: #a2a5ae;
}

.login-form-scan-wx {
  width: 32px;
  height: 32px;
  background-image: url('../../assets/images/wx-login.png');
  background-size: 100% 100%;
  cursor: pointer;
  margin-left: 16px;
}

.login-form-scan-jjt {
  width: 32px;
  height: 32px;
  margin-left: 16px;
  background-image: url('../../assets/images/jjt-login.png');
  background-size: 100% 100%;
  cursor: pointer;
}

:deep(.arco-checkbox-label) {
  font-size: 16px;
}

:deep(.arco-checkbox-icon) {
  width: 12px;
  height: 12px;
  border: 1px solid #fff;
}

:deep(.arco-icon-left) {
  width: 26px;
  height: 26px;
  margin-top: 2px;
}
</style>
